import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Calendar } from "lucide-react";
import { BookLink } from "./BookLink";
import { Logo } from "./Navbar";
import { PHONE, PHONE_HREF, EMAIL, EMAIL_HREF, SERVICE_AREAS, SERVICES } from "../config";

export const MobileCTA = () => (
    <div className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-white/90 backdrop-blur-xl border-t border-slate-200 px-4 py-3 flex gap-3">
        <BookLink
            data-testid="mobile-sticky-book-button"
            className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-blue-700 text-white text-sm font-semibold py-3 active:scale-95 transition-transform"
        >
            <Calendar className="h-4 w-4" />
            Book an Appointment
        </BookLink>
        <a
            data-testid="mobile-sticky-call-button"
            href={PHONE_HREF}
            className="inline-flex items-center justify-center gap-2 rounded-full border border-[#0A192F] text-[#0A192F] text-sm font-semibold px-5 py-3 active:scale-95 transition-transform"
        >
            <Phone className="h-4 w-4" />
            Call
        </a>
    </div>
);

export const Footer = () => (
    <footer data-testid="footer-section" className="bg-[#0A192F] text-slate-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16 sm:py-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
            <div className="space-y-5">
                <Logo stacked />
                <p className="font-display italic text-2xl text-white">Move Better. Live Stronger.</p>
                <p className="text-sm leading-relaxed text-slate-400">
                    Premium chiropractic and wellness care serving South Dallas and surrounding areas.
                </p>
            </div>
            <div>
                <h3 className="text-xs uppercase tracking-[0.25em] text-sky-400 font-semibold mb-5">Explore</h3>
                <ul className="space-y-3 text-sm">
                    <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
                    <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
                    <li><Link to="/about" className="hover:text-white transition-colors">About Dr. Lane</Link></li>
                    <li><Link to="/contact" className="hover:text-white transition-colors">Contact &amp; Book</Link></li>
                </ul>
            </div>
            <div>
                <h3 className="text-xs uppercase tracking-[0.25em] text-sky-400 font-semibold mb-5">Services</h3>
                <ul className="space-y-3 text-sm">
                    {SERVICES.map((s) => (
                        <li key={s.id}>
                            <Link to={`/services#${s.id}`} className="hover:text-white transition-colors">{s.title}</Link>
                        </li>
                    ))}
                </ul>
            </div>
            <div>
                <h3 className="text-xs uppercase tracking-[0.25em] text-sky-400 font-semibold mb-5">Contact</h3>
                <ul className="space-y-4 text-sm">
                    <li>
                        <a data-testid="footer-phone-link" href={PHONE_HREF} className="flex items-center gap-3 hover:text-white transition-colors">
                            <Phone className="h-4 w-4 text-sky-400" /> {PHONE}
                        </a>
                    </li>
                    <li>
                        <a data-testid="footer-email-link" href={EMAIL_HREF} className="flex items-center gap-3 hover:text-white transition-colors">
                            <Mail className="h-4 w-4 text-sky-400" /> {EMAIL}
                        </a>
                    </li>
                    <li className="flex items-start gap-3 text-slate-400">
                        <MapPin className="h-4 w-4 text-sky-400 mt-0.5 shrink-0" />
                        Serving {SERVICE_AREAS.slice(0, 6).join(", ")} &amp; surrounding areas
                    </li>
                </ul>
            </div>
        </div>
        <div className="border-t border-white/10">
            <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
                <p>© {new Date().getFullYear()} Chirolane &amp; Wellness, LLC. All rights reserved.</p>
                <p className="font-display italic text-slate-400">Move Better. Live Stronger.</p>
            </div>
        </div>
        <div className="h-16 md:hidden" />
    </footer>
);
